import template from "./bFloatingHeader.html";

export function bFloatingHeaderDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bFloatingHeaderController,
    controllerAs: 'bFloatingHeader',
    bindToController: true,
    scope: {
      headers: "=?",
      noActions: "=",
      actionsTitleVisible: "=?",
      options: "=?"
    }
  };

  return directive;
}

class bFloatingHeaderController {
  constructor () {
    'ngInject';
  }

  getHeaderClass(th) {
    return th.class;
  }
}
